import React, { useEffect, useState } from 'react'
import AxiosAuth from '../../utility/AxiosAuth';
import ConfigApi from '../../utility/ConfigApi';
import InitInfo from '../../utility/InitInfo';
import { useTemplate } from '../../context/TemplateProvider';
import { Link } from 'react-router-dom';

function FinanceAccountType() {
    const {userId} = InitInfo();
    const [typeData, setTypeData] = useState()    
    const [accData, setAccData] = useState()
    const {setMessage,setLoading,setHeaderText,reloadKey,setReloadKey}=useTemplate()

    useEffect(()=>{
        setHeaderText('Account Type')
        if (userId) {
          setLoading(123);
          AxiosAuth.post(ConfigApi.ACCOUNT_TYPE_LIST, {userId})
            .then(({data}) => {
              setLoading();
  
              if (data.error===0) {
                setAccData(data.data?.accAr);
                setTypeData(data.data?.typeAr);
              }else{
                setMessage({type: 'error', text: data.message})
              }
              
            })
            .catch(err => {
              console.log(err);
            });
        }
    },[userId,reloadKey])

    let Sl=1;

  return (
    <div>
        <div className="relative overflow-x-auto sm:rounded-lg">
            <div className="pb-4 bg-white dark:bg-gray-900">
                
            </div>
            <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
                <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                    <tr>
                        <th scope="col" className="p-4">
                            SL
                        </th>
                        <th scope="col" className="px-6 py-3">
                            Type
                        </th>
                        <th scope="col" className="px-6 py-3">
                            Code
                        </th>                        
                        <th scope="col" className="px-6 py-3">
                            Action
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {typeData && typeData?.map((row)=>(
                    <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600" key={row.sl}>
                        <td className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                          {Sl++}
                        </td>
                        <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                            {row.type}
                        </th>
                        <td className="px-6 py-4">
                            {row.code}
                        </td>
                        <td className="px-6 py-4">
                            <Link to={`/finance/${row?.type}/${row?.code}/account/list`} >View</Link>
                            
                        </td>                                           
                    </tr>
                    ))}
                </tbody>
            </table>
        </div>
    </div>
  )
}

export default FinanceAccountType